// frontend/src/pages/SskTravels.jsx
import React, { useState, useRef } from "react";
import DriverService from "./driverService";
import OneWayDrop from "./one-way-drop";
import { InfoCard } from "./infoCard";
import { cars, services } from "./data";
import Footer from "./footer";
import {ContactWatsapp} from "./watsapp";
import { BookingForm } from "./bookinForm";
import { Phone,Mail,Car,Star,Users,User,ArrowRight,Zap,Palette} from "lucide-react";
import CarRental from "./rentalCars";
import Header from "./header";
import { HomeHeroSection } from "./homeHeroSection";

const Welcome = () => {
    const [activeTab, setActiveTab] = useState("cab");
    const scrollRef = useRef(null);
    const [showForm,setShowForm] = useState(false)

    return (
        <div className="min-h-screen bg-gradient-to-b from-slate-900 via-gray-900 to-indigo-950">

            <Header setBookForm = {setShowForm}/>
            {/* Hero Section */}
            <HomeHeroSection setShowForm = {setShowForm} setTab={setActiveTab} activeTab={activeTab} scrollRef={scrollRef}/>

            {showForm && <BookingForm setBookForm = {setShowForm}/>}

            {/* Service Content Section */}
            <section className="py-12" ref={scrollRef}>
                <div className="container mx-auto px-4">
                    {/* Cab Service - All 8 Cars */}
                    {activeTab === "cab" && (
                        <div className="animate-fadeIn">
                            <div className="text-center mb-10">
                                <div className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-blue-500 via-cyan-400 to-indigo-500 rounded-full text-white mb-4 shadow-lg">
                                    <Palette className="h-4 w-4 mr-2" />
                                    <span className="text-sm font-semibold">
                                        COLORFUL FLEET
                                    </span>
                                </div>
                                <h2 className="text-3xl font-bold text-white mb-4">
                                    Our Colorful Fleet
                                </h2>
                                <p className="text-white max-w-2xl mx-auto">
                                    Choose from our vibrant range of premium
                                    vehicles, all with professional drivers
                                </p>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
                                {cars.map((car) => (
                                    <div
                                        key={car.id}
                                        className="bg-white rounded-2xl shadow-xl border border-gray-200 hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 overflow-hidden group"
                                    >
                                        <div
                                            className={`relative h-48 overflow-hidden bg-gradient-to-br`}
                                        >
                                            <img
                                                src={car.image}
                                                alt={car.name}
                                                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500 mix-blend bg-white"
                                            />
                                            <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm text-gray-900 px-3 py-1 rounded-full text-sm font-bold shadow-md">
                                                {car.price}
                                            </div>
                                            <div className="absolute bottom-3 left-3 bg-black/70 text-white px-3 py-1 rounded-full text-sm shadow-md">
                                                <Users className="inline h-3 w-3 mr-1" />
                                                {car.seats} seats
                                            </div>
                                        </div>

                                        <div className="p-5">
                                            <div className="flex justify-between items-start mb-3">
                                                <div>
                                                    <h3 className="text-xl font-bold text-gray-900">
                                                        {car.name}
                                                    </h3>
                                                    <p className="text-gray-700 text-sm">
                                                        {car.type}
                                                    </p>
                                                </div>
                                                <div className="flex items-center bg-gradient-to-r from-yellow-100 to-orange-100 text-amber-800 px-2 py-1 rounded-full text-sm shadow-sm">
                                                    <Star className="h-3 w-3 mr-1 fill-current" />
                                                    {car.rating}
                                                </div>
                                            </div>

                                            <div className="flex flex-wrap gap-2 mb-4">
                                                {car.features
                                                    .slice(0, 2)
                                                    .map((feature, idx) => (
                                                        <span
                                                            key={idx}
                                                            className="px-2 py-1 bg-gradient-to-r from-blue-50 to-cyan-50 text-blue-700 text-xs font-medium rounded shadow-sm"
                                                        >
                                                            {feature}
                                                        </span>
                                                    ))}
                                            </div>

                                            <div className="flex items-center justify-between">
                                                <div className="flex items-center text-sm text-gray-700">
                                                    <User className="h-4 w-4 text-emerald-500 mr-1" />
                                                    <span className="font-medium">
                                                        Driver Included
                                                    </span>
                                                </div>
                                                <button onClick={() => setShowForm(true)}
                                                    className="px-4 py-2 bg-gradient-to-r from-blue-500 to-cyan-500 text-white rounded-lg font-semibold hover:shadow-lg hover:shadow-blue-500/30 transition-all duration-300 text-sm shadow-md"
                                                >
                                                    Book Now
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* One Way Drop - All Routes */}
                    {activeTab === "oneway" && <OneWayDrop setForm = {setShowForm}/>}

                    {/* Acting Driver Services */}
                    {activeTab === "driver" && <DriverService setForm = {setShowForm}/>}

                    {/* Rental Packages */}
                    {activeTab === "rental" && <CarRental setForm = {setShowForm}/>}
                </div>
            </section>

            {/* CTA Section */}
            <section className="py-20 to-slate-900">
                <div className="container mx-auto px-4">
                    <div className="max-w-4xl mx-auto text-center">
                        <div className="inline-flex items-center px-4 py-2 bg-amber-500/10 border border-amber-500/30 rounded-full text-amber-400 mb-6">
                            <Zap className="h-4 w-4 mr-2" />
                            <span className="text-sm font-semibold">
                                INSTANT BOOKING
                            </span>
                        </div>

                        <h2 className="text-4xl font-bold mb-6 text-white">
                            Ready for a Comfortable Ride?
                        </h2>
                        <p className="text-lg text-gray-300 mb-10 max-w-2xl mx-auto">
                            Book your reliable and premium cab service with SSK
                            Travels
                        </p>

                        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
                            <button onClick={() => setShowForm(true)}
                                className="group px-8 py-4 bg-amber-500 text-slate-900 rounded-xl font-semibold hover:bg-amber-400 transition-all shadow-xl"
                            >
                                <span className="flex items-center justify-center">
                                    <Car className="mr-3 h-5 w-5" />
                                    Book Online
                                    <ArrowRight className="ml-3 h-5 w-5 group-hover:translate-x-1 transition-transform" />
                                </span>
                            </button>

                            <a
                                href="tel:9551776782"
                                className="group px-8 py-4 bg-white/5 text-white rounded-xl font-semibold hover:bg-white/10 transition-all border border-white/20"
                            >
                                <span className="flex items-center justify-center">
                                    <Phone className="mr-3 h-5 w-5" />
                                    Call: 9551776782
                                </span>
                            </a>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                            <InfoCard
                                icon={<Phone />}
                                title="9551776782"
                                subtitle="Primary Contact"
                                accent="amber"
                            />
                            <InfoCard
                                icon={<Phone />}
                                title="6381714992"
                                subtitle="Secondary Contact"
                                accent="emerald"
                            />
                            <InfoCard
                                icon={<Mail />}
                                title="appu955177672@gmail.com"
                                subtitle="Email Support"
                                accent="violet"
                            />
                        </div>
                    </div>
                </div>
            </section>

            {/* {Footer} */}
            <Footer services={services} />
            <ContactWatsapp/>

            {/* Custom CSS */}
            <style jsx global>{`
                @keyframes blob {
                    0% {
                        transform: translate(0px, 0px) scale(1);
                    }
                    33% {
                        transform: translate(30px, -50px) scale(1.1);
                    }
                    66% {
                        transform: translate(-20px, 20px) scale(0.9);
                    }
                    100% {
                        transform: translate(0px, 0px) scale(1);
                    }
                }

                .animate-blob {
                    animation: blob 7s infinite;
                }

                .animation-delay-2000 {
                    animation-delay: 2s;
                }

                .animation-delay-4000 {
                    animation-delay: 4s;
                }

                .animation-delay-1000 {
                    animation-delay: 1s;
                }

                .animation-delay-3000 {
                    animation-delay: 3s;
                }

                @keyframes fadeIn {
                    from {
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                .animate-fadeIn {
                    animation: fadeIn 0.5s ease-out;
                }

                @keyframes gradient {
                    0%,
                    100% {
                        background-position: 0% 50%;
                    }
                    50% {
                        background-position: 100% 50%;
                    }
                }

                .animate-gradient {
                    animation: gradient 3s ease infinite;
                    background-size: 200% 200%;
                }

                /* Custom scrollbar */
                ::-webkit-scrollbar {
                    width: 10px;
                }

                ::-webkit-scrollbar-track {
                    background: linear-gradient(to bottom, #f0f9ff, #fdf4ff);
                    border-radius: 5px;
                }

                ::-webkit-scrollbar-thumb {
                    background: linear-gradient(
                        to bottom,
                        #3b82f6,
                        #8b5cf6,
                        #ec4899
                    );
                    border-radius: 5px;
                }

                ::-webkit-scrollbar-thumb:hover {
                    background: linear-gradient(
                        to bottom,
                        #2563eb,
                        #7c3aed,
                        #db2777
                    );
                }
            `}</style>
        </div>
    );
};

export default Welcome;
